import { useEffect, useState } from "react";
import ListExperience from "../Components/MyPage/ListExperience";
import ListInvitation from "../Components/MyPage/ListInvitation";
import ListReview from "../Components/MyPage/ListReview";
import {
  BASE_URL,
  getAllExperience,
  getAllInvitation,
  getAllInvitationAttend,
  getAllReview,
  getDataUser,
  logout,
  upload,
} from "../Store/Action";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  ArrowRight,
  Camera,
  ChevronLeft,
  ChevronRight,
  Home,
  Play,
} from "lucide-react";
import ListDoneReview from "../Components/MyPage/ListDoneReview";
import Card from "../Components/Home/Recent";
import default_image from "../assets/default_image.png";
import { useFetchRun } from "../Hooks/useFetch";
import { useThemeClass } from "@/Hooks/useThemeClass";
import clsx from "clsx";
import { useTheme } from "styled-components";
import famtourGrouping from "@/utils/famtourGrouping";
import filterAndSortCampaigns from "@/utils/filterAndSortCampaigns";

const S3_URL = import.meta.env.VITE_S3_URL;
const weuBeuaty = import.meta.env.VITE_APP_THEME
function MyPage() {
  const themeClass = useThemeClass();
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState("experience");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [dataAcc, setDataAcc] = useState([]);

  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem("token");
    navigate("/login");
  };

  const [totalExperience, setTotalExperience] = useState(0);
  let dataInvitation = useSelector(
    (state) => state.ReducerListInvitation.invitationData?.data || []
  );
  const dataReview = useSelector(
    (state) => state.ReducerListInvitationAttend.dataAttend?.data || []
  );
  const dataDoneReview = useSelector(
    (state) => state.ReducerReview.review?.data || []
  );
  const dataUser = useSelector((state) => state.ReducerDataUser?.dataUser);
  const loading = useSelector((state) => state.ReducerDataUser?.loading);

  let dataExperience = useSelector(
    (state) => state.ReducerListExperience.experienceData?.data || []
  );

  dataExperience = filterAndSortCampaigns(dataExperience);
  dataExperience = famtourGrouping(dataExperience);
  dataInvitation = famtourGrouping(dataInvitation);



  let themes = weuBeuaty == "weubeauty" ? "beauty" : "all" 
  const {
    fetchData,
    loading: loadingAcc,
    error,
    executeFetch,
  } = useFetchRun({
    url: `${BASE_URL}/user/subscription/list?status=acc&category=${themes}`,
    method: "GET",
  });

  useEffect(() => {
    executeFetch();
  }, []);

  useEffect(() => {
    if (fetchData) {
      setDataAcc(fetchData.data);
    }
  }, [fetchData]);

  useEffect(() => {
    dispatch(getAllReview());
    dispatch(getAllInvitation());
    dispatch(getAllInvitationAttend());
    dispatch(getDataUser());
    dispatch(getAllExperience());
    executeFetch();
  }, [activeTab]);

  // useEffect(() => {
  //   dispatch(getAllInvitation()); // Ambil data pertama kali

  //   const interval = setInterval(() => {
  //   dispatch(getAllExperience());

  //     dispatch(getAllInvitation()); // Ambil data secara berkala
  //   }, 3000); // Refresh setiap 5 detik

  //   return () => clearInterval(interval); // Hapus interval saat komponen unmount
  // }, []);

  const handleCameraClick = () => {
    document.getElementById("fileInput").click();
  };

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file)); // Menampilkan preview sebelum upload
      setIsUploading(true);

      try {
        const imagePath = await dispatch(upload(file, "profile", 300));
        if (imagePath) {
          dispatch(getDataUser()); // Ambil ulang data user setelah upload berhasil

          // Simpan ke localStorage setelah sukses
          const newProfileImage = `${S3_URL}${imagePath}`;
          // console.log(newProfileImage);
          setWithExpiry("profileImage", newProfileImage);
        }
      } catch (error) {
        console.error("Upload failed", error);
      } finally {
        setTimeout(() => {
          setIsUploading(false);
        }, 2000);
      }
    }
  };
  const profileImage =
    selectedImage ||
    (dataUser?.data?.photo ? `${S3_URL}${dataUser.data.photo}` : default_image);

  const handleProfile = () => {
    setIsHidden(!isHidden);
  };


  return (
    <>
      <div className="px-3">
        <div
          className={`${
            isHidden
              ? clsx(
                  `justify-between flex items-center py-3 border-b mb-2`,
                  themeClass.text("text"),
                  themeClass.border("text")
                )
              : "hidden"
          }`}
        >
          <Link
            to={`${isHidden ? "" : "/"}`}
            onClick={() => setIsHidden(false)}
          >
            <ChevronLeft />
          </Link>
          <div>
            <p className="text-[18px]  font-bold">정보수정</p>
          </div>
          <Link to={"/"} className="flex text-sm items-center text-center">
            <Home />
          </Link>
        </div>
      </div>

      <div className={`${isHidden ? "hidden" : "relative w-full"}`}>
        <div
          className={clsx(
            `absolute inset-0 w-screen h-18 left-1/2 -translate-x-1/2 -z-10`
          )}
          style={{ background: theme.colors.backgroundGradient }}
        />
        {/* <div className="bg-gradient-to-b from-[#46B6D0] to-[#0F1E6C] h-16 w-full"></div> */}
        {isUploading ? (
          <div className="bg-white absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rounded-full">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-500"></div>
          </div>
        ) : (
          <div className=" w-full h-full flex justify-center items-center transform translate-y-1/2">
            <div className="relative w-20 h-20">
              <img
                src={profileImage}
                className="rounded-full w-20 h-20 object-cover"
                onError={(e) => (e.target.src = default_image)}
              />
              <div
                className="absolute bottom-0 right-0 bg-white shadow-md p-1 rounded-full"
                onClick={handleCameraClick}
              >
                <Camera className={clsx(themeClass.text("text"), `w-4 h-4`)} />
              </div>
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleImageChange}
              />
            </div>
          </div>
        )}
      </div>
      <div
        className={`${
          isHidden
            ? "hidden"
            : "font-bold text-[#0F1E6C] text-[22px] text-center mt-12"
        }`}
      >
        <p>{dataUser?.data?.nick_name}</p>
      </div>

      <div
        className={`${
          isHidden
            ? "hidden"
            : "flex justify-center pt-1 rounded-full px-2 py-1"
        }`}
      >
        <Link to="/mypage/updateprofile">
          <button className="bg-[#F1EBF7] text-[#8660B2] rounded-full px-4 text-xs py-1">
            정보수정
          </button>
        </Link>
      </div>

      <div className="px-3 min-h-[80vh] ">
        {/* <div
          className={`${
            isHidden
              ? "hidden"
              : clsx(themeClass.border('text'), `justify-between flex items-center mb-4 py-4 border-b`)
          }`}
        >
          <div>
            <p className="text-[16px] font-bold">나의 캠페인</p>
          </div>
          <div
            onClick={handleProfile}
            className="flex text-sm items-center text-center text-[#999999] hover:text-[#46B6D0]"
          >
            <p>전체보기</p>
            <ChevronRight width={16} />
          </div>
        </div> */}

        {isHidden ? (
          <>
            <div className="flex items-center w-full mt-6">
              <div
                className={`${
                  activeTab === "experience"
                    ? clsx(
                        themeClass.text2("text2"),
                        themeClass.border2("text"),
                        `border-b text-center justify-center flex items-center gap-2 w-full cursor-pointer`
                      )
                    : "border-b text-center justify-center flex items-center gap-2 w-full cursor-pointer"
                }`}
                onClick={() => setActiveTab("experience")}
              >
                <p className="font-medium text-sm">신청</p>
                <p
                  className={`font-bold text-sm ${
                    activeTab === "experience" ? "" : "text-gray-300"
                  }`}
                >
                  {dataExperience?.length}
                </p>
              </div>
              <div
                className={`${
                  activeTab === "invitation"
                    ? clsx(
                        themeClass.text2("text2"),
                        themeClass.border2("text"),
                        `border-b text-center justify-center flex items-center gap-2 w-full cursor-pointer`
                      )
                    : "border-b text-center justify-center flex items-center gap-2 w-full cursor-pointer"
                }`}
                onClick={() => setActiveTab("invitation")}
              >
                <p className="font-medium text-sm">선정</p>
                <p
                  className={`font-bold text-sm ${
                    activeTab === "invitation" ? "" : "text-gray-300"
                  }`}
                >
                  {dataInvitation?.length}
                </p>
              </div>
              <div
                className={`${
                  activeTab === "review"
                    ? clsx(
                        themeClass.text2("text2"),
                        themeClass.border2("text"),
                        `border-b text-center justify-center flex items-center gap-2 w-full cursor-pointer`
                      )
                    : "border-b text-center justify-center flex items-center gap-2 w-full cursor-pointer"
                }`}
                onClick={() => setActiveTab("review")}
              >
                <p className="font-medium text-sm">리뷰</p>
                <p
                  className={`font-bold text-sm ${
                    activeTab === "review" ? "" : "text-gray-300"
                  }`}
                >
                  {dataReview?.length}
                </p>
              </div>
              <div
                className={`${
                  activeTab === "finish"
                    ? clsx(
                        themeClass.text2("text2"),
                        themeClass.border2("text"),
                        `border-b text-center justify-center flex items-center gap-2 w-full cursor-pointer`
                      )
                    : "border-b text-center justify-center flex items-center gap-2 w-full cursor-pointer"
                }`}
                onClick={() => setActiveTab("finish")}
              >
                <p className="font-medium text-sm">종료</p>
                <p
                  className={`font-bold text-sm ${
                    activeTab === "finish" ? "" : "text-gray-300"
                  }`}
                >
                  {dataAcc?.length}
                </p>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="grid grid-cols-4 w-full pt-4 ">
              {/* 신청 */}
              <div
                className={`text-center cursor-pointer border-b pb-1
                ${
                  activeTab === "experience"
                    ? `${clsx(
                        themeClass.text2("text2"),
                        themeClass.border2("text2")
                      )}`
                    : "text-gray-300"
                }
                `}
                onClick={() => setActiveTab("experience")}
              >
                <p className={`font-bold text-sm`}>
                  신청 {dataExperience?.length}
                </p>
                {/* <p className={clsx(`font-medium text-sm`)}>신청</p> */}
              </div>

              {/* 선정 */}
              <div
                className={`text-center cursor-pointer border-b pb-1
                ${
                  activeTab === "invitation"
                    ? `${clsx(
                        themeClass.text2("text2"),
                        themeClass.border2("text2")
                      )}`
                    : "text-gray-300"
                }
                `}
                onClick={() => setActiveTab("invitation")}
              >
                <p className={`font-bold text-sm`}>
                  선정 {dataInvitation?.length || 0}
                </p>
                {/* <p className={clsx(`font-medium text-sm`)}>선정</p> */}
              </div>

              {/* 등록 */}
              <div
                className={`text-center cursor-pointer border-b pb-1
                ${
                  activeTab === "review"
                    ? `${clsx(
                        themeClass.text2("text2"),
                        themeClass.border2("text2")
                      )}`
                    : "text-gray-300"
                }
                `}
                onClick={() => setActiveTab("review")}
              >
                <p className={`font-bold text-sm`}>
                  등록 {dataReview?.length || 0}
                </p>
                {/* <p className={clsx(`font-medium text-sm`)}>리뷰</p> */}
              </div>

              {/* 종료 */}
              <div
                className={`text-center cursor-pointer border-b pb-1
                ${
                  activeTab === "finish"
                    ? `${clsx(
                        themeClass.text2("text2"),
                        themeClass.border2("text2")
                      )}`
                    : "text-gray-300"
                }
                `}
                onClick={() => setActiveTab("finish")}
              >
                <p className={`font-bold text-sm`}>
                  종료 {dataAcc?.length || 0}
                </p>
                {/* <p className={clsx(`font-medium text-sm`)}>종료</p> */}
              </div>
            </div>
          </>
        )}

        <div className="mt-4">
          {activeTab === "experience" && (
            <ListExperience dataExperience={dataExperience} />
          )}
          {activeTab === "invitation" && (
            <ListInvitation
              dataInvitation={dataInvitation}
              setActiveTab={setActiveTab}
            />
          )}
          {activeTab === "review" && (
            <ListReview dataReview={dataReview} setActiveTab={setActiveTab} />
          )}
          {activeTab === "finish" && (
            <ListDoneReview dataDoneReview={dataAcc} />
          )}
        </div>

        <div
          className={`${
            isHidden
              ? "hidden"
              : clsx(
                  themeClass.border("text"),
                  `justify-between flex items-center mb-4 mt-4 py-4 border-b`
                )
          }`}
        >
          <div>
            <p className="text-[16px] font-bold">
              관심 캠페인 <span className="text-[#8660B2]">3개</span>
            </p>
          </div>
          <Link
            to={"/interest-campaign"}
            className={`${clsx(
              themeClass.hoverText("text")
            )} flex text-sm items-center text-center text-[#999999] hover:text-[#46B6D0]`}
          >
            <p>전체보기</p>
            <ChevronRight width={12} />
          </Link>
        </div>
        <div className={isHidden ? "hidden" : ""}>
          <Card ctgId={0} />
        </div>
      </div>
      <div
        className={`${
          isHidden ? "hidden" : "flex w-full justify-center items-center px-4 "
        }`}
      >
        <button
          onClick={handleLogout}
          className={clsx(
            themeClass.bg("text"),
            `w-full text-white py-3 rounded-full mt-3`
          )}
        >
          로그아웃
        </button>
      </div>
    </>
  );
}

export default MyPage;
